import React, { useState, useEffect } from 'react';
import { Home, Smartphone } from 'lucide-react';
import GuestBookingForm from './GuestBookingForm';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const BookingSection = () => {
  const [apartments, setApartments] = useState([]);

  useEffect(() => {
    fetchApartments();
  }, []);

  const fetchApartments = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/public/apartments`);
      setApartments(response.data.apartments || []);
    } catch (error) {
      console.error('Error fetching apartments:', error);
    }
  };

  return (
    <section id="booking" className="py-6 bg-gradient-to-b from-amber-50 to-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-4">
          <h2 className="text-2xl md:text-3xl font-bold text-amber-900 mb-1">
            Book Your Stay
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-sm">
            Fill out the form and we'll confirm your booking within 24 hours.
          </p>
        </div>

        {/* Booking Form Card */}
        <div className="bg-white rounded-xl shadow-lg p-4 md:p-5 border border-amber-100">
          <div className="flex items-center gap-2 mb-3 pb-2 border-b border-gray-100">
            <Home className="w-4 h-4 text-amber-600" />
            <h3 className="text-base font-semibold text-gray-800">Guest Registration</h3>
          </div>
          
          <GuestBookingForm apartments={apartments} />
        </div>

        {/* Payment Section - M-Pesa */}
        <div className="mt-4 bg-white rounded-xl shadow-lg p-5 border border-green-100">
          <div className="flex items-center gap-2 text-green-700 mb-4">
            <Smartphone className="w-5 h-5" />
            <h4 className="font-bold text-lg">Pay via M-Pesa</h4>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-start">
            {/* QR Code - Enlarged */}
            <div className="flex justify-center">
              <div className="bg-white p-2 rounded-lg shadow-md border-2 border-green-200">
                <img 
                  src="/images/payment/mpesa-qr.jpg" 
                  alt="M-Pesa Payment QR Code - Marina Homes" 
                  className="w-40 h-auto rounded-lg"
                />
              </div>
            </div>
            
            {/* Payment Instructions */}
            <div className="space-y-3">
              <div className="bg-green-50 rounded-lg p-3">
                <p className="text-gray-700 text-sm">
                  <span className="font-semibold">Account Number:</span>
                  <span className="ml-2 font-bold text-green-700 text-lg">351410134</span>
                </p>
                <p className="text-gray-700 text-sm mt-1">
                  <span className="font-semibold">Account Name:</span>
                  <span className="ml-2 font-bold">MARINA HOMES</span>
                </p>
              </div>
              
              <div className="text-sm text-gray-700 space-y-2">
                <p className="font-semibold text-gray-800">How to Pay:</p>
                <ol className="list-decimal list-inside space-y-1 text-gray-600">
                  <li>Scan QR code with M-Pesa app <span className="text-gray-500">OR</span></li>
                  <li>Dial <span className="font-bold text-green-700">*150*00#</span></li>
                  <li>Select "Lipa kwa simu"</li>
                  <li>Enter account: <span className="font-bold">351410134</span></li>
                  <li>Enter amount and confirm</li>
                  <li>Send confirmation screenshot via WhatsApp</li>
                </ol>
              </div>
              
              <p className="text-xs text-gray-500 bg-gray-50 p-2 rounded">
                ✓ Pay from all mobile networks (Vodacom, Airtel, Tigo, Halotel) and all banks
              </p>
            </div>
          </div>
        </div>

        {/* Info Cards - More Compact */}
        <div className="grid grid-cols-3 gap-2 mt-4">
          <div className="bg-white rounded-lg p-2 shadow-sm border border-gray-100 text-center">
            <span className="text-lg">⚡</span>
            <p className="font-semibold text-gray-800 text-xs">24hr Response</p>
          </div>
          <div className="bg-white rounded-lg p-2 shadow-sm border border-gray-100 text-center">
            <span className="text-lg">🔒</span>
            <p className="font-semibold text-gray-800 text-xs">Secure Data</p>
          </div>
          <div className="bg-white rounded-lg p-2 shadow-sm border border-gray-100 text-center">
            <span className="text-lg">💬</span>
            <p className="font-semibold text-gray-800 text-xs">24/7 Support</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BookingSection;
